import { useRef, useContext, useState, useEffect } from 'react';

import { GlobalContext } from "../../contexts/globalContext";
import styles from './LiftPanelButton.module.css';

const LiftPanelButton = ({ showContent }) => {

    const ref = useRef();
    const [panelIsDown, setPanelIsDown] = useState(true)
    const { localSocketRef } = useContext(GlobalContext);

    useEffect(() => {
        ref.current.className = styles.component_disabled;
        if (localSocketRef.current?.connected) {

            if (localSocketRef.current?.connected) {
                console.log("Sending serial:getLimitStatus");
                localSocketRef.current.emit("serial:getLimitStatus", (status) => {
                    setPanelIsDown(status.panel === "down");
                    if (status.panel !== "down") {
                        console.log("Sending serial:lowerPanel");
                        localSocketRef.current.emit("serial:lowerPanel");
                    } else {
                        ref.current.className = styles.component;
                    }
                });
            }
        }

        localSocketRef.current?.on("serial:limitStatusUpdated", (status) => {
            ref.current.className = styles.component;
            setPanelIsDown(status.panel === "down");
        })

        return () => {
            localSocketRef.current?.off("serial:limitStatusUpdated");
        }
    }, [])

    const click_handler = async () => {
        ref.current.className = styles.component_disabled;


        if (localSocketRef.current?.connected) {
            if (panelIsDown) {
                localSocketRef.current.emit("serial:liftPanel");
            } else {
                localSocketRef.current.emit("serial:lowerPanel");
            }
        }
    }

    return (
        <div ref={ref} className={styles.component} onClick={() => click_handler()} style={{ display: showContent ? "flex" : "none" }}>
            <i style={{ transform: panelIsDown ? "rotate(0deg)" : "rotate(180deg)" }} className={styles.icon + " fa-solid fa-arrow-up-from-bracket"}></i>

            <div className={styles.text}>PANEL</div>
            <div className={styles.text}>{panelIsDown ? "UP" : "DOWN"}</div>

        </div>
    );

}

export default LiftPanelButton;